import React from "react";
import { useRecoilState } from "recoil";
import ScreenCard from "../ScreenCard";
import { newMissionState } from "../../atoms/core";
import { CreateMissionScreensContext } from "../../contexts/CreateMissionManager";
import { useI18n } from "../../hooks/i18n-hooks";
import MissionEarningType from "../../components/editors/MissionEarningType";
import { EarningType, Repetition, Unit } from "../../__generated__/graphql";
import { Bubble } from "../../components/Bubble";
import { useBubbleStepOrigin } from "../../hooks/use-bubble-step-origin";

const CLEAN_WORKING_TIME_CLASSIC_PACKAGE = {
    repetition: Repetition.None,
    unit: Unit.Hours,
    unitCount: undefined,
};

const CreateMissionEarningType = () => {
    const i18n = useI18n();
    const [mission, setMission] = useRecoilState(newMissionState);
    const { validateScreen } = React.useContext(CreateMissionScreensContext);
    const setEarningType = React.useCallback(
        (earningType: EarningType) => {
            setMission((oldMission) => {
                return {
                    ...oldMission,
                    currentContract: {
                        ...oldMission.currentContract,
                        earningType,
                        ...(earningType === EarningType.Package
                            ? {
                                  workingTimeClassicSpec: oldMission.currentContract
                                      ?.workingTimeClassicSpec
                                      ? {
                                            ...oldMission.currentContract?.workingTimeClassicSpec,
                                            ...CLEAN_WORKING_TIME_CLASSIC_PACKAGE,
                                        }
                                      : CLEAN_WORKING_TIME_CLASSIC_PACKAGE,
                              }
                            : {
                                  workingTimeClassicSpec: undefined,
                              }),
                    },
                };
            });
        },
        [setMission],
    );

    const validate = React.useCallback(() => {
        void validateScreen("CreateMissionEarningType");
    }, [validateScreen]);

    const origin = useBubbleStepOrigin("CreateMissionEarningType");

    return (
        <ScreenCard
            buttons={[
                {
                    title: i18n.translate("next"),
                    onPress: validate,
                    isValid:
                        !!mission.currentContract?.earningType &&
                        !!mission.currentContract?.hoursPerWeekFullTime,
                },
            ]}
        >
            <Bubble
                title={i18n.t("screens.user.create_mission_earning_type.title")}
                origin={origin}
                bubbleStyle={{ paddingBottom: 0 }}
            >
                <MissionEarningType
                    mission={mission}
                    setEarningType={setEarningType}
                ></MissionEarningType>
            </Bubble>
        </ScreenCard>
    );
};

export default CreateMissionEarningType;
